import { styled } from '@mui/material/styles';
import { getDrugTestThemeTokens } from '../themeTokens';
import type { ResolutionTone } from './types';

export const SectionLabel = styled('p')(({ theme }) => ({
  fontSize: 12,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  color: getDrugTestThemeTokens(theme).textMuted,
  margin: '0 0 14px',
}));

export const SummaryGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
  gap: '14px 24px',
  marginBottom: 0,
});

export const SummaryItem = styled('div')({
  minWidth: 0,
});

export const SummaryLabel = styled('span')(({ theme }) => ({
  display: 'block',
  fontSize: 10,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  color: getDrugTestThemeTokens(theme).textMuted,
  marginBottom: 3,
  fontWeight: 600,
  lineHeight: 1.2,
}));

export const SummaryValue = styled('span')(({ theme }) => ({
  fontSize: 13,
  lineHeight: 1.4,
  display: 'block',
  color: getDrugTestThemeTokens(theme).text,
}));

export const Mono = styled('span')({
  fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace',
  fontSize: 12,
});

export const RecheckBadge = styled('span')(({ theme }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '3px 8px',
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 600,
    background: t.sourceBadge.bgc_screening.background,
    color: t.textMuted,
    border: `1px solid ${t.border}`,
  };
});

export const ResolutionValue = styled('span', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: ResolutionTone }>(({ theme, tone }) => ({
  fontSize: 13,
  lineHeight: 1.4,
  display: 'block',
  fontWeight: 600,
  color: getDrugTestThemeTokens(theme).resolutionText[tone],
}));
